import { List, Set } from 'immutable';
import React from 'react';
import {
  Tabs, Tab, Tooltip, OverlayTrigger, Button
} from 'react-bootstrap';
import UIActions from 'src/stores/alt/actions/UIActions';
import UserActions from 'src/stores/alt/actions/UserActions';
import Search from 'src/apps/mydb/elements/list/search/Search';
import ElementActions from 'src/stores/alt/actions/ElementActions';
import SelectionActions from 'src/apps/mydb/elements/list/selectionActions/SelectionActions';
import MatrixCheck from 'src/components/common/MatrixCheck';
import CreateElementButton from 'src/components/navigation/CreateElementButton';
import ElementsTable from 'src/apps/mydb/elements/list/ElementsTable';
import ElementsTableSettings from 'src/apps/mydb/elements/list/ElementsTableSettings';
import ElementStore from 'src/stores/alt/stores/ElementStore';
import UIStore from 'src/stores/alt/stores/UIStore';
import UserStore from 'src/stores/alt/stores/UserStore';
import { StoreContext } from 'src/stores/mobx/RootStore';
import { allElnElements } from 'src/apps/generic/Utils';
import { capitalizeWords } from 'src/utilities/textHelper';

function getVisibleAndHiddenFromLayout(layout) {
  const visible = [];
  const hidden = [];
  Object.keys(layout).forEach((key) => {
    if (layout[key] < 0) {
      hidden.push(key);
    } else {
      visible.push(key);
    }
  });

  return {
    visible: List(visible).sortBy((t) => layout[t]),
    hidden: List(hidden).sortBy((t) => -1 * layout[t]),
  };
}

export default class ElementsList extends React.Component {
  static contextType = StoreContext;

  constructor(props) {
    super(props);
    this.state = {
      totalElements: {},
      visible: List(),
      hidden: List(),
      genericEls: [],
      currentTab: 0,
      totalCheckedElements: {},
      currentCollection: null,
    };

    this.onChange = this.onChange.bind(this);
    this.onChangeUser = this.onChangeUser.bind(this);
    this.onChangeUI = this.onChangeUI.bind(this);
    this.handleTabSelect = this.handleTabSelect.bind(this);
  }

  componentDidMount() {
    ElementStore.listen(this.onChange);
    UserStore.listen(this.onChangeUser);
    UIStore.listen(this.onChangeUI);

    this.onChange(ElementStore.getState());
    this.onChangeUser(UserStore.getState());
    this.onChangeUI(UIStore.getState());
  }

  componentWillUnmount() {
    ElementStore.unlisten(this.onChange);
    UserStore.unlisten(this.onChangeUser);
    UIStore.unlisten(this.onChangeUI);
  }

  onChange(state) {
    const { totalElements } = this.state;
    Object.keys(state.elements).forEach((key) => {
      totalElements[key] = state.elements[key]?.totalElements;
    });

    this.setState({
      totalElements
    });
  }

  onChangeUser(state) {
    let visible = List();
    let hidden = List();
    let { currentType, currentTab } = state;

    if (state?.profile?.data?.layout) {
      const profileConfig = getVisibleAndHiddenFromLayout(state.profile.data.layout);
      visible = profileConfig.visible;
      hidden = profileConfig.hidden;

      currentTab = visible.findIndex((e) => e === currentType);
      if (currentType === '') { currentType = visible.get(0); }
    }

    if (currentTab < 0) currentTab = 0;

    this.setState({
      genericEls: state.genericEls || [],
      currentTab,
      visible,
      hidden
    });
  }

  onChangeUI(state) {
    const { totalCheckedElements, currentCollection } = this.state;
    // const genericNames = (genericEls && genericEls.map(el => el.name)) || [];
    let genericKlasses = [];
    const currentUser = (UserStore.getState() && UserStore.getState().currentUser) || {};
    if (MatrixCheck(currentUser.matrix, 'genericElement')) {
      const { klasses } = UIStore.getState();
      genericKlasses = klasses;
    }

    const elNames = allElnElements.concat(genericKlasses);

    const newTotalCheckedElements = {};
    let needsUpdate = false;
    elNames.forEach((type) => {
      const elementUI = state[type] || {
        checkedAll: false,
        checkedIds: List(),
        uncheckedIds: List(),
      };
      const element = ElementStore.getState().elements[`${type}s`];
      const nextCount = elementUI.checkedAll
        ? (element.totalElements - elementUI.uncheckedIds.size)
        : elementUI.checkedIds.size;
      needsUpdate = needsUpdate || nextCount !== totalCheckedElements[type];
      newTotalCheckedElements[type] = nextCount
    });

    if (needsUpdate || currentCollection !== state.currentCollection) {
      this.setState({
        totalCheckedElements: newTotalCheckedElements,
        currentCollection: state.currentCollection
      });
    }
  }

  handleRemoveSearchResult(searchStore) {
    searchStore.changeShowSearchResultListValue(false);
    UIActions.clearSearchById();
    ElementActions.changeSorting(false);
    const { currentCollection } = UIStore.getState();
    UIActions.selectCollection(currentCollection);
  }

  handleTabSelect(tab) {
    UserActions.selectTab(tab);

    // TODO sollte in tab action handler
    const uiState = UIStore.getState();
    const { visible } = this.state;
    const type = visible.get(tab);

    if (!uiState[type] || !uiState[type].page) { return; }

    const { page } = uiState[type];

    UIActions.setPagination({ type, page });
  }

  render() {
    const {
      visible, hidden, totalCheckedElements, totalElements, currentTab, currentCollection
    } = this.state;
    const { search } = this.context;
    const { overview = true } = this.props;

    const hasSearchApplied = !!UIStore.getState().currentSearchByID;

    const constEls = Set(allElnElements);
    const tabItems = visible.map((value, i) => {
      let iconClass = `icon-${value}`;
      let ttl = (
        <Tooltip>
          {value && (capitalizeWords(value))}
        </Tooltip>
      );

      let genericEl = null;
      if (!constEls.has(value)) {
        const { genericEls } = this.state;
        genericEl = (genericEls && genericEls.find((el) => el.name === value)) || {};
        iconClass = `${genericEl.icon_name} icon_generic_nav`;
        ttl = (
          <Tooltip>
            {genericEl.label}
            <br />
            {genericEl.desc}
          </Tooltip>
        );
      }

      const title = (
        <OverlayTrigger
          overlay={ttl}
          placement="top"
        >
          <span>
            <i className={`me-1 ${iconClass}`} />
            {`${totalElements[`${value}s`] || 0} (${totalCheckedElements[value] || 0})`}
          </span>
        </OverlayTrigger>
      );

      return (
        <Tab
          key={value}
          eventKey={i}
          title={title}
          className={`elements-list-tab-${value}s`}
        >
          <ElementsTable
            type={value}
            genericEl={genericEl}
          />
        </Tab>
      );
    });

    return (
      <div className="elements-list h-100 d-flex flex-column" style={{ minWidth: '400px' }}>
        <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap column-gap-4 row-gap-2">
          <h1 className="m-0 text-capitalize">
            {currentCollection?.label || ''}
            {hasSearchApplied && (<span className="ms-2 text-lighten2 condensed-text-width">(search results)</span>)}
          </h1>
          <div className="d-flex align-items-center gap-3">
            {hasSearchApplied ? (
              <Button
                variant="light"
                onClick={() => this.handleRemoveSearchResult(search)}
              >
                <i className="fa fa-times-circle me-2" />
                Clear search
              </Button>
            ) : <Search />}
            {overview && <CreateElementButton />}
          </div>
        </div>
        <SelectionActions />
        <div className="tabs-container--with-full-grow position-relative">
          <ElementsTableSettings
            visible={visible}
            hidden={hidden}
          />
          <Tabs
            id="tabList"
            activeKey={currentTab}
            onSelect={(eventKey) => this.handleTabSelect(parseInt(eventKey, 10))}
            className="surface-tabs has-config-overlay"
          >
            {tabItems}
          </Tabs>
        </div>
      </div>
    );
  }
}
